import React from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import { actions, useModal } from '../../../context/results-modal-context';
import styles from './moreInfo.module.scss';
import { ReactComponent as MoreInfoIcon } from '../../../static/icon-add.svg';

const MoreInfoCell = ({ node }: ICellRendererParams) => {
  const { dispatch } = useModal();

  const openModal = () => {
    dispatch(actions.setResult(node.data));
    dispatch(actions.openModal());
  };

  return (
    <button
      data-testid="PT-moreInfoCell-onOpenModalButton"
      className={styles.moreInfoBtn}
      onClick={openModal}
    >
      <MoreInfoIcon className={styles.moreInfoIcon} />
    </button>
  );
};

export { MoreInfoCell };
